<template>
  <div class="ListItem">
    <img class="order" :src="ord" v-if="item.rank <= 25" />
    <div class="order" v-else>
      {{ item.rank }}
    </div>

    <div class="name">{{item.name}}</div>
    <div class="score">{{item.score}}</div>
    <div class="area">{{item.area}}</div>
  </div>
</template>

<script> export default {
  name: 'ListItem',
  props: ['item', 'undo'],
   computed: {
     ord() {
       if(this.undo && this.item.rank<4)
         return '/oss/images/wap/rank/undo-rank-'+this.item.rank+'.png'
       return '/oss/images/wap/rank/rank-'+this.item.rank+'.png'
     }
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .ListItem{
   width: 95vw;
   height: 10vh;
   display: flex;
   background: linear-gradient(to bottom, #265687, #2c62a1 100%);
   align-items: center;
   justify-content:space-around;
   color: rgba(240,240,240, 0.7);
   margin-top: 10px;
   font-size: 14px;
 }
 .order{
   width: 50px;
   font-size: 35px;
 text-align: center;

 }
 .name{
   width: 60px;
 }
 .score{
   width: 50px;
 }
 .area{
   width: 50px;
 }
 .name, .score, .area{
   text-align: center;
 }
</style>
